// MODÜL 15: YOLCU HİZMETLERİ

const cabinCrewContentsM15 = {
  // ==================== KABİN SERVİSİ ====================
  'CM-M15-U1-L1': {
    lesson_id: 'CM-M15-U1-L1',
    title: 'Servis Prosedürleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Servis Prosedürleri',
      paragraphs: [
        'Pre-Service: Trolley hazırlığı, malzeme kontrolü, galley düzeni.',
        'Service Flow: Önden arkaya veya ortadan başlayarak. Havayoluna göre değişir.',
        'Business First: Önce Business Class servisi tamamlanır, sonra Economy.',
        'Hot Towel: Sıcak havlu servisi. Özellikle uzun uçuşlarda ve Business Class\'ta.',
        'Post-Service: Toplama, çöp, temizlik, galley düzeni.'
      ],
      keyPoints: [
        'Pre-Service hazırlık',
        'Business önce',
        'Hot towel servisi',
        'Post-Service temizlik'
      ]
    }
  },
  'CM-M15-U1-L2': {
    lesson_id: 'CM-M15-U1-L2',
    title: 'Trolley Yönetimi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Trolley ve Ekipman',
      paragraphs: [
        'Meal Trolley: Yemek servis arabası. Atlas veya KSSU boyutları.',
        'Beverage Cart: İçecek arabası. Soğuk ve sıcak içecekler.',
        'Brake Kullanımı: Her duraklamada fren! Güvenlik zorunluluğu.',
        'Ergonomi: Beli koruyun. İtme, çekme değil. Dizleri kullanın.',
        'Koridor Geçişi: Yolcuları uyarın. "Excuse me, service coming through."'
      ],
      keyPoints: [
        'Meal vs Beverage cart',
        'Freni kullan!',
        'Ergonomik kullanım',
        'Koridor uyarısı'
      ]
    }
  },
  'CM-M15-U1-L3': {
    lesson_id: 'CM-M15-U1-L3',
    title: 'Özel Yemekler (SPML)',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Özel Yemek Kodları - SPML',
      paragraphs: [
        'SPML: Special Meal. Önceden sipariş edilir. Boarding\'den önce kontrol et.',
        'VGML: Vegetarian (Vegan). Hiç hayvansal ürün yok.',
        'VLML: Vegetarian Lacto-Ovo. Süt ve yumurta var, et yok.',
        'HNML: Hindu Meal. Domuz ve sığır yok.',
        'KSML: Kosher. Yahudi kurallarına uygun. Mühürlü gelir.',
        'MOML: Muslim Meal. Helal et. Alkol yok.',
        'DBML: Diabetic. Düşük şeker.',
        'GFML: Gluten Free. Çölyak hastalığı için.'
      ],
      keyPoints: [
        'VGML = Vegan',
        'KSML = Kosher',
        'MOML = Müslüman',
        'GFML = Glütensiz'
      ]
    }
  },
  'CM-M15-U1-L4': {
    lesson_id: 'CM-M15-U1-L4',
    title: 'Servis Sıralaması',
    type: 'dragdrop',
    duration: 4,
    xp: 40,
    dragdrop: {
      instruction: 'Uzun uçuş servis sırasını belirleyin',
      items: [
        { text: '1️⃣ Hoş geldiniz içeceği', order: 1 },
        { text: '2️⃣ Sıcak havlu (Business)', order: 2 },
        { text: '3️⃣ İçecek servisi', order: 3 },
        { text: '4️⃣ Yemek servisi', order: 4 },
        { text: '5️⃣ Çay/Kahve', order: 5 },
        { text: '6️⃣ Toplama', order: 6 }
      ]
    }
  },

  // ==================== ÖZEL YOLCULAR ====================
  'CM-M15-U2-L1': {
    lesson_id: 'CM-M15-U2-L1',
    title: 'VIP ve CIP Yolcular',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'VIP/CIP Yolcu Hizmeti',
      paragraphs: [
        'VIP: Very Important Person. Devlet başkanları, bakanlar, CEO\'lar.',
        'CIP: Commercially Important Person. Sık uçan üst düzey müşteriler.',
        'Hizmet: Öncelikli boarding, kişisel ilgi, isimle hitap.',
        'Mahremiyet: Fotoğraf çekme, sosyal medya paylaşımı YASAK.',
        'Protokol: Havayolu protokol departmanından bilgi alınır.'
      ],
      keyPoints: [
        'VIP = Devlet, CEO',
        'CIP = Sık uçan',
        'İsimle hitap',
        'Mahremiyet önemli'
      ]
    }
  },
  'CM-M15-U2-L2': {
    lesson_id: 'CM-M15-U2-L2',
    title: 'Refakatsiz Çocuklar (UM)',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Unaccompanied Minor (UM)',
      paragraphs: [
        'UM: Yetkilin refakatsiz seyahat eden çocuk. Genellikle 5-12 yaş.',
        'UMNR Form: Ebeveyn bilgileri, karşılayıcı bilgileri.',
        'Dikkat: Sürekli gözetim. Ön sıralara oturtur.',
        'Teslim: Sadece formda belirtilen kişiye. Kimlik kontrolü zorunlu.',
        'Ekstra İlgi: Oyun, boyama kitabı, özel yemek.'
      ],
      keyPoints: [
        'UM = 5-12 yaş',
        'Sürekli gözetim',
        'Kimlik kontrollü teslim',
        'Özel ilgi'
      ]
    }
  },
  'CM-M15-U2-L3': {
    lesson_id: 'CM-M15-U2-L3',
    title: 'Engelli Yolcular (PRM)',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'PRM - Hareket Kısıtlı Yolcular',
      paragraphs: [
        'PRM: Passengers with Reduced Mobility. Fiziksel veya zihinsel engel.',
        'WCHC: Wheelchair Cabin. Kabinde yardım gerekir. Koltuğa taşınır.',
        'WCHR: Wheelchair Ramp. Merdiven çıkabilir, uzun yürüyüş yapamaz.',
        'WCHS: Wheelchair Steps. Merdiven çıkamaz.',
        'BLND: Görme engelli. DEAF: İşitme engelli.',
        'Saygılı İletişim: "Yardıma ihtiyacınız var mı?" diye sorun. Varsaymayın.'
      ],
      keyPoints: [
        'WCHC = Kabin yardımı',
        'WCHR = Rampa yardımı',
        'WCHS = Merdiven yardımı',
        'Saygılı yaklaşım'
      ]
    }
  },
  'CM-M15-U2-L4': {
    lesson_id: 'CM-M15-U2-L4',
    title: 'Yolcu Kodu Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      pairs: [
        { id: 1, left: 'UM', right: 'Refakatsiz Çocuk' },
        { id: 2, left: 'WCHC', right: 'Kabin Yardımı Gereken' },
        { id: 3, left: 'VIP', right: 'Çok Önemli Kişi' },
        { id: 4, left: 'BLND', right: 'Görme Engelli' },
        { id: 5, left: 'MOML', right: 'Müslüman Yemeği' },
        { id: 6, left: 'VGML', right: 'Vegan Yemek' }
      ]
    }
  },

  // ==================== ZOR YOLCULAR ====================
  'CM-M15-U3-L1': {
    lesson_id: 'CM-M15-U3-L1',
    title: 'Şikayet Yönetimi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Şikayet ve Sorun Yönetimi',
      paragraphs: [
        'Dinle: Yolcuyu kesme. Göz teması kur. Anlaşıldığını hissettir.',
        'Empati: "Anlıyorum, bu can sıkıcı olmalı." Savunmaya geçme.',
        'Çözüm Öner: "Sizin için şunu yapabilirim..."',
        'Özür Dile: Hata varsa kabul et. Şirket adına özür dile.',
        'Takip: Söz verdiğini yap. Geri dön.'
      ],
      keyPoints: [
        'Dinle, kesme',
        'Empati kur',
        'Çözüm öner',
        'Takip et'
      ]
    }
  },
  'CM-M15-U3-L2': {
    lesson_id: 'CM-M15-U3-L2',
    title: 'Alkollü Yolcu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Alkollü Yolcu Yönetimi',
      paragraphs: [
        'Belirti: Dengesiz yürüyüş, yüksek ses, peltek konuşma, kızarıklık.',
        'Servis Reddi: Fazla alkol servisi yapma. Yasal hak!',
        'De-escalation: Sakin tonda konuş. Karşı çıkma. Su/kahve öner.',
        'Bilgilendirme: Kıdemli kabin memurunu ve kaptani bilgilendir.',
        'Kayıt: Olay raporu tut. Tanık isimleri al.'
      ],
      keyPoints: [
        'Alkol servisini kes',
        'Sakin kal',
        'Kaptana bilgi ver',
        'Rapor yaz'
      ]
    }
  },
  'CM-M15-U3-L3': {
    lesson_id: 'CM-M15-U3-L3',
    title: 'Zor Yolcu Senaryoları',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Yolcu bağırarak koltuk değiştirmek istiyor. Dolu uçuş. Ne yaparsınız?',
      context: 'Yolcu yanındaki bebekten şikayetçi, agresif.',
      options: [
        { id: 'A', text: 'Sakin konuşur, empati kurar, alternatif ararrım', isCorrect: true },
        { id: 'B', text: '"Böyle bir imkan yok" der geçerim', isCorrect: false },
        { id: 'C', text: 'Bebek sahibine taşınmasını söylerim', isCorrect: false },
        { id: 'D', text: 'Güvenliği çağırırım', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Empati + sakinlik + çözüm arayışı. Belki crew seat veya başka çözüm.',
        wrong: 'Hatalı. Agresyona agresyonla karşılık verme. Empati ve çözüm odaklı ol.'
      },
      explanation: 'De-escalation: 1) Dinle, 2) Anla, 3) Empati kur, 4) Çözüm ara, 5) Gerekirse üst bilgilendir.'
    }
  },

  // ==================== DUTY FREE ====================
  'CM-M15-U4-L1': {
    lesson_id: 'CM-M15-U4-L1',
    title: 'Duty Free Prosedürü',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Duty Free Satış',
      paragraphs: [
        'Duty Free: Vergisiz satış. Uçuş sırasında özel fiyatlar.',
        'Katalog: Satış broşürü. Koltuk ceplerinde bulunur.',
        'Ödeme: Kredi kartı, nakit (EUR, USD, TRY). POS cihazı kullan.',
        'Makbuz: Fiş ver. Gümrük için gerekli olabilir.',
        'Envanter: Satış sonrası rapor. Eksik/fazla sayım.'
      ],
      keyPoints: [
        'Vergisiz fiyatlar',
        'Çoklu para birimi',
        'Makbuz zorunlu',
        'Envanter raporu'
      ]
    }
  },
  'CM-M15-U4-L2': {
    lesson_id: 'CM-M15-U4-L2',
    title: 'Satış Teknikleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Etkili Satış Teknikleri',
      paragraphs: [
        'Proaktif: "Bugün\'s special" diye tanıt. İndirimli ürünleri vurgula.',
        'Cross-Sell: "Bu parfümle şu losyon çok uyumlu."',
        'Upsell: "Biraz daha eklerseniz büyük boy alabilirsiniz."',
        'Hediye Önerisi: "Hediye paketlememi ister misiniz?"',
        'Nazik Kapatış: "Başka bir şeye ihtiyacınız olursa buradayım."'
      ],
      keyPoints: [
        'Proaktif tanıtım',
        'Cross-sell & Upsell',
        'Hediye önerisi',
        'Nazik kapatış'
      ]
    }
  },
  'CM-M15-U4-L3': {
    lesson_id: 'CM-M15-U4-L3',
    title: 'Satış Quiz',
    type: 'quiz',
    duration: 5,
    xp: 35,
    quiz: {
      questions: [
        { q: 'Duty Free ne demek?', options: ['Bedava', 'Vergisiz', 'Sınırlı', 'Özel'], correct: 1 },
        { q: 'Cross-sell nedir?', options: ['İndirim', 'Ek ürün önerme', 'Büyük boy satma', 'İade'], correct: 1 },
        { q: 'Makbuz neden önemli?', options: ['Reklam', 'Gümrük', 'Dekorasyon', 'Önemsiz'], correct: 1 },
        { q: 'Uçakta hangi paralar kabul edilir?', options: ['Sadece TRY', 'Sadece EUR', 'Çoklu para', 'Hiçbiri'], correct: 2 }
      ]
    }
  },

  // ==================== SERVİS OYUNLARI ====================
  'CM-M15-U5-L1': {
    lesson_id: 'CM-M15-U5-L1',
    title: 'Servis Zaman Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'VGML ne demek?', options: ['Vegan', 'Vejeteryan', 'Gülten free', 'Kosher'], correct: 0 },
        { q: 'UM ne demek?', options: ['VIP', 'Refakatsiz çocuk', 'Engelli', 'Yaşlı'], correct: 1 },
        { q: 'WCHC ne demek?', options: ['Kargo', 'Kabin yardımı', 'Kör', 'Sağır'], correct: 1 },
        { q: 'Alkollü yolcuya ne yapmalı?', options: ['Daha ver', 'Servisi kes', 'Görmezden gel', 'Kovuştur'], correct: 1 },
        { q: 'De-escalation ilk adımı?', options: ['Bağır', 'Dinle', 'Kaç', 'Gül'], correct: 1 }
      ]
    }
  },
  'CM-M15-U5-L2': {
    lesson_id: 'CM-M15-U5-L2',
    title: 'Boşluk Doldur: Servis',
    type: 'fillin',
    duration: 4,
    xp: 40,
    fillin: {
      sentences: [
        { text: 'Refakatsiz çocuk kodu: ___', answer: 'UM' },
        { text: 'Vegan yemek kodu: ___', answer: 'VGML' },
        { text: 'Tekerlekli sandalye + kabin yardımı: ___', answer: 'WCHC' },
        { text: 'Vergisiz satış: Duty ___', answer: 'Free' },
        { text: 'Öfkeli yolcuya yaklaşım: De-___', answer: 'escalation' }
      ]
    }
  }
};

export default cabinCrewContentsM15;
